import { InjectionToken, Type } from '@angular/core';

/**
 * Carries the host component that ModalContentService hands to NgbModal.open().
 *
 * The service used to `import { ModalContentComponent }` directly, but that
 * created a circular dependency: ModalContentService → ModalContentComponent →
 * feature components (payment-method, deliveries, explorer-payment-method,
 * prospect, …) → back to ModalContentService/AccountService. Depending on how
 * esbuild split the chunks, ModalContentComponent could evaluate after the
 * service captured it, leaving it `undefined` at `open()` (TypeError reading
 * 'ɵcmp'). Resolving the component through this token — provided in app.config,
 * which no feature component imports — removes that static edge so the service
 * is never part of the cycle.
 */
export const MODAL_CONTENT_COMPONENT = new InjectionToken<Type<unknown>>('MODAL_CONTENT_COMPONENT');
